import { StyleSheet } from 'aphrodite/no-important';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (options: any) => {
  const { darkmode, basic, hasCalendarHeadline } = options;
  const mainColor = darkmode ? 'white' : 'black';
  return StyleSheet.create({
    header: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      marginBottom: 18,
      [children('*:not(:last-child)')]: {
        marginBottom: 10,
      },
      [children('*:last-child')]: {
        marginBottom: 0,
      },
      [media.tablet]: {
        marginBottom: 48,
        [children(':not(:last-child)')]: {
          marginBottom: 15,
        },
      },
      [media.desktop]: {
        marginBottom: 53,
      },
    },
    headline: {
      color: basic ? palette.black : palette.red,
      fontSize: 25,
      lineHeight: 35 / 25,
      [media.tablet]: {
        fontSize: 40,
        lineHeight: 50 / 40,
      },
    },
    subheadline: {
      fontSize: 16,
      lineHeight: 22 / 16,
    },
    calendarBannerHeadline: {
      backgroundColor: palette.red,
      color: palette.white,
      fontWeight: 'bold',
      padding: '15px',
      textAlign: 'center',
      fontSize: '20px',
      [media.smallerThanTablet]: {
        marginLeft: basic ? -16 : -15,
        marginRight: basic ? -16 : -15,
      },
      [media.tablet]: {
        fontSize: '27px',
        padding: '20px',
      },
      [media.desktop]: {
        fontSize: '28px',
        padding: '20px',
      },
    },
    calendar: {
      color: mainColor,
      [media.smallerThanTablet]: {
        marginLeft: basic ? -16 : -15,
        marginRight: basic ? -16 : -15,
      },
      [children('a')]: {
        position: 'relative',
        color: mainColor,
        marginBottom: '3px',
        ':after': {
          display: 'block',
          position: 'absolute',
          content: '""',
          width: '100%',
          opacity: 1,
          height: '2px',
          left: '0',
          top: 'calc(100% + 1px)',
          transition: 'all 0.2s linear',
          background: palette.red,
          [media.desktop]: {
            width: 0,
            opacity: 0,
          },
        },
        ':hover:after': {
          width: '100%',
          opacity: 1,
        },
      },
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      borderTop: `1px solid ${mainColor}`,
      ':first-child': {
        borderTop: hasCalendarHeadline ? 'none' : `1px solid ${mainColor}`,
      },
      ':last-child': {
        borderBottom: `1px solid ${mainColor}`,
      },
      [children(' > div:not(:first-child)')]: {
        borderLeft: `1px solid ${mainColor}`,
      },
      [media.smallerThanTablet]: {
        flexDirection: 'column',
        border: 'none',
        borderTop: basic ? `1px solid ${mainColor}` : 'none',
        ':not(:last-child)': {
          borderBottom: `1px solid ${mainColor}`,
        },
        ':last-child': {
          borderBottom: 'none',
        },

        [children('> div:not(:first-child)')]: {
          border: 'none',
        },
      },
      [media.tablet]: {
        minHeight: '155px',
      },
    },
    streamingBadge: {
      width: 'fit-content',
      padding: '12px 20px',
      marginTop: 10,
      borderRadius: 5,
      fontSize: 16,
      lineHeight: 19 / 16,
      color: palette.white,
      backgroundColor: palette.red,
      [media.smallerThanTablet]: {
        // backgroundColor: basic ? palette.red : palette.white,
        // color: basic ? palette.white : palette.red,
      },
    },
    rowHeader: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      width: '30%',
      padding: 25,
      fontSize: basic ? '20px' : '16px',
      lineHeight: basic ? '24px' : '20px',
      fontWeight: 'bold',
      [media.smallerThanTablet]: {
        alignItems: basic ? 'center' : 'center',
        textAlign: basic ? 'center' : 'center',
        width: '100%',
        fontSize: basic ? '20px' : '20px',
        lineHeight: basic ? '24px' : '20px',
        padding: basic ? '20px 0 0 0' : '20px 0px 10px 0px',
        // backgroundColor: basic ? 'inherit' : palette.red,
      },
      [media.tablet]: {
        fontSize: 20,
        lineHeight: 24 / 20,
      },
      [media.desktop]: {
        fontSize: 28,
        lineHeight: 34 / 28,
      },
    },
    rowContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'stretch',
      textAlign: 'center',
      width: '70%',
      [children(' > div:not(:last-child)')]: {
        borderBottom: `1px solid ${mainColor}`,
      },
      [media.smallerThanTablet]: {
        width: '100%',
        [children(' > div:not(:last-child)')]: {
          border: 'none',
        },
      },
    },
    defaultContent: {
      textAlign: 'left',
      padding: 40,
      fontWeight: 500,
      [children('p')]: {
        margin: 5,
      },
      [children('li')]: {
        listStyleType: 'disc',
        listStylePosition: 'inside',
        textIndent: '-20px',
        paddingLeft: '20px',
      },
      [media.smallerThanTablet]: {
        [children('h1')]: {
          fontSize: '16px',
          lineHeight: '20px',
        },
        fontSize: '16px',
        lineHeight: '20px',
        textAlign: 'center',
        padding: basic ? '20px 0' : '10px 20px 20px 20px',
      },

      [media.desktop]: {
        fontSize: 18,
      },
    },
    table: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,

      [children('ul')]: {
        listStylePosition: 'outside',
      },

      [children(' > div:not(:last-child)')]: {
        borderBottom: `1px solid ${mainColor}`,
      },
      [media.smallerThanTablet]: {
        [children('> div:not(:last-child)')]: {
          border: 'none',
        },
      },
    },
    calendarCell: {
      position: 'relative',
      height: '100%',
      width: '100%',
    },
    separator: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '72%',
      borderRight: `1px dashed ${mainColor}`,
      [media.smallerThanTablet]: {
        display: 'none',
      },
    },
    tableTitle: {
      fontWeight: 'bold',
      padding: 30,
      fontSize: 22,
      lineHeight: 34 / 22,
      [children('a')]: {
        marginBottom: '4px',
        ':after': {
          height: '3px',
          [media.smallerThanTablet]: {
            display: 'none',
          },
        },
      },
      [media.smallerThanTablet]: {
        fontSize: 20,
        lineHeight: 23 / 20,
        padding: 20,
        backgroundColor: palette.red,
      },
    },
    tableContent: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      [children('li')]: {
        listStyleType: 'disc',
        listStylePosition: 'inside',
        textIndent: '-20px',
        paddingLeft: '20px',
        [media.smallerThanTablet]: {
          listStyleType: 'none',
          textIndent: '0',
          paddingLeft: '0',
        },
      },
    },
    tableListContent: {
      padding: '20px 0px',
      justifyContent: 'center',
      [media.smallerThanTablet]: {
        padding: 0,
        [children('li')]: {
          listStyleType: 'none',
          fontWeight: 'bold',
        },
        [children('> div:nth-child(even)')]: {
          backgroundColor: palette.lightDarkGrey,
        },
      },
    },
    tableStripedContent: {
      [media.tablet]: {
        [children('> div:nth-child(odd)')]: {
          backgroundColor: palette.lightDarkGrey,
        },
      },
      [media.smallerThanTablet]: {
        [children('> div:nth-child(even)')]: {
          backgroundColor: palette.lightDarkGrey,
        },
      },
    },
    tableRow: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      [media.smallerThanTablet]: {},
      [media.tablet]: {
        flexDirection: 'row',
      },
    },
    tableRowColumnSeparator: {
      [media.tablet]: {
        flexDirection: 'row',
        [children('> div:not(:first-child)')]: {
          borderLeft: `1px dashed ${mainColor}`,
        },
      },
    },
    tableCell: {
      fontWeight: 500,
      textAlign: 'left',
      display: 'flex',
      alignItems: 'center',
      padding: 20,
      [media.smallerThanTablet]: {
        width: '100%',
        ':first-child': {
          paddingBottom: 0,
        },
        ':last-child': {
          paddingTop: 0,
          [children('b')]: {
            fontWeight: '500',
          },
        },
      },
      [media.tablet]: {
        padding: '15px 20px',
        ':first-child': {
          paddingLeft: 40,
        },
      },
      [media.desktop]: {
        fontSize: 18,
        padding: '15px 20px',
        ':first-child': {
          paddingRight: 40,
        },
        ':last-child': {
          paddingLeft: 40,
        },
      },
    },
    listTableCell: {
      [media.tablet]: {
        padding: '3px 20px',
      },
      [media.desktop]: {
        padding: '3px 20px',
      },
    },
    presenterCell: {
      color: '#C1C0C0',
      [media.tablet]: {
        color: 'white',
      },
    },
  });
};

export const tableStyle: any = (columns: number) => {};
